var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      visible: _vm.previewVisible,
      title: _vm.$t("新增") + _vm.$t("地址"),
      okText: _vm.$t("保存"),
      cancelText: _vm.$t("取消"),
      width: 1000
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      },
      ok: _vm.handleSure
    }
  }, [_c("a-form-model", {
    ref: "from",
    attrs: {
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      },
      model: _vm.mailingInfo,
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("收件人"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("收件人")
    },
    model: {
      value: _vm.mailingInfo.name,
      callback: function ($$v) {
        _vm.$set(_vm.mailingInfo, "name", $$v);
      },
      expression: "mailingInfo.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("手机号"),
      prop: "mobile"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("手机号")
    },
    model: {
      value: _vm.mailingInfo.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.mailingInfo, "mobile", $$v);
      },
      expression: "mailingInfo.mobile"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("具体地址"),
      prop: "address"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("具体地址")
    },
    model: {
      value: _vm.mailingInfo.address,
      callback: function ($$v) {
        _vm.$set(_vm.mailingInfo, "address", $$v);
      },
      expression: "mailingInfo.address"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };